import { STRINGS } from 'config';
import { useEffect, useState } from 'react';
/**
 * Custom React hook to track recording time.
 *
 * @param {boolean} isRecording - Determines if recording is active.
 * @param {boolean} isPaused - Determines if recording is paused.
 * @param {string | null} error - Captures any errors that may occur.
 * @returns {Object} - Returns formatted time and a reset function.
 */

const {
  TRANSCRIBE: { MAX_RECORDING_TIME_SECONDS },
} = STRINGS;

export const useRecordingTimer = (isRecording: boolean, isPaused: boolean, error: string | null) => {
  const [secondsElapsed, setSecondsElapsed] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;
    if (isRecording && !isPaused && !error) {
      interval = setInterval(() => {
        setSecondsElapsed(prev => {
          if (prev < MAX_RECORDING_TIME_SECONDS) {
            return prev + 1;
          }
          return prev;
        });
      }, 1000);
    }
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isRecording, isPaused, error]);

  const resetTimer = () => setSecondsElapsed(0);

  const minutes = Math.floor(secondsElapsed / 60);
  const seconds = secondsElapsed % 60;
  const formattedTime = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

  return { formattedTime, resetTimer, secondsElapsed };
};
